export default "/images/framework/KeepUp.c45281c2.svg?c45281c2";